import { Component, HostBinding } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-uat-flag",
  templateUrl: "./uat-flag.component.html",
  standalone: true,
  styleUrls: ["./uat-flag.component.scss"],
  imports: [CommonModule]
})

export class UatFlagComponent {

  isUat: boolean = window.location.href.toLowerCase()
    .includes('-uat.');

  @HostBinding('style.display') public get display() {
    return this.isUat ? 'flex' : 'none';
  }

}